import {
  SAVE_EXPERIMENTS,
  Experiments,
  SaveExperimentsAction,
} from 'redux/modules/experiments/actions/types';

export const saveExperiments = ({
  decisions,
  payloads,
  impressions,
  bypassMonetate,
  preview,
}: Experiments): SaveExperimentsAction => ({
  type: SAVE_EXPERIMENTS,
  decisions,
  payloads,
  impressions,
  bypassMonetate,
  preview,
});
